import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import get from 'lodash/get';
import PropTypes from 'prop-types';

import MessagesHeaderComponent from '../components/MessagesHeaderComponent';

import { getBuildingsForFilter } from '../../Building/actionCreators';
import { onModalClose, showRenderPropsModal } from '../../Modal/actions';
import { clearChats } from '../actions';

import { getInitialSelectValue } from '../utils';

const MessagesHeaderContainer = ({
  getBuildings,
  buildingId,
  selectValue,
  setSelectValue,
  history,
  baseUrl,
  openModal,
  closeModal,
  pmcId,
  search,
  setSearchValue,
}) => {
  const [selectOptions, setSelectOptions] = useState([]);
  const [hasTwoOrMoreBuildings, setHasTwoOrMoreBuildings] = useState(false);

  const onSelectChange = (event, value) => {
    if (!value) {
      setSelectValue(getInitialSelectValue());
    } else {
      setSelectValue(value);
    }
    history.replace(`${baseUrl}/messages`);
  };

  const getSelectOptions = async () => {
    const rawBuildings = await getBuildings();
    let buildings = get(rawBuildings, 'data', []);
    if (pmcId && buildings && buildings.length) {
      buildings = buildings.filter(
        (building) => get(building, 'parent.id') === pmcId,
      );
    }
    setHasTwoOrMoreBuildings(buildings && buildings.length > 1);
    let options = [getInitialSelectValue()];
    if (buildings) {
      buildings.map((property) => {
        options = [...options, { value: property.id, label: property.name }];
        return false;
      });
    }
    return setSelectOptions(options);
  };

  useEffect(() => {
    getSelectOptions();
  }, []);

  return (
    <MessagesHeaderComponent
      hasTwoOrMoreBuildings={hasTwoOrMoreBuildings}
      buildingId={buildingId}
      selectValue={selectValue}
      onSelectChange={onSelectChange}
      selectOptions={selectOptions}
      openModal={openModal}
      closeModal={closeModal}
      search={search}
      setSearchValue={setSearchValue}
    />
  );
};

MessagesHeaderContainer.propTypes = {
  getBuildings: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  buildingId: PropTypes.number,
  pmcId: PropTypes.number,
  selectValue: PropTypes.instanceOf(Object),
  history: PropTypes.instanceOf(Object),
  setSelectValue: PropTypes.func.isRequired,
  setSearchValue: PropTypes.func.isRequired,
  baseUrl: PropTypes.string,
  search: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  const { match } = ownProps;
  const pmcId = Number(get(match, 'params.PMCId', null));
  const buildingId = Number(get(match, 'params.buildingId', null));
  return {
    pmcId,
    buildingId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getBuildings: () => getBuildingsForFilter(dispatch),
  openModal: (props) => showRenderPropsModal(dispatch, props),
  closeModal: () => onModalClose(dispatch),
  clearChats: () => clearChats(dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MessagesHeaderContainer);
